import React from 'react';
import PropTypes from 'prop-types';

const styles = {};

export default class Settings extends React.Component {
  static propTypes = {
    color: PropTypes.string,
    style: PropTypes.object,
  };

  static defaultProps = {
    color: '#97A1A5',
    style: {width: 16, height: 16},
  };

  render() {
    return (
      <svg
        style={this.props.style}
        viewBox='0 0 14 10'
        xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M2.04 2l5.097 4.883 4.823-4.85'
          stroke={this.props.color}
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
          fill='none'
          fillRule='evenodd'
        />
      </svg>
    );
  }
}
